import Nullstack from 'nullstack';
export default function IconHeadsetOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-headset-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "13",
    width: "4",
    height: "6",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M17.185 13.173a2 2 0 0 1 2.815 1.827v1m-1.18 2.825a2 2 0 0 1 -2.82 -1.825v-1"
  }), "   ", Nullstack.element("path", {
    d: "M4 15v-3c0 -2.208 .894 -4.207 2.34 -5.654m2.377 -1.643a8 8 0 0 1 11.283 7.297v3"
  }), "   ", Nullstack.element("path", {
    d: "M18 19c0 1.657 -2.686 3 -6 3"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}